import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_error: 'Preencha os campos para continuar.',
  },
  es: {
    modal_error: 'Complete los campos para continuar.',
  },
  en: {
    modal_error: 'Please fill in all the fields to proceed.',
  },
};

export const presenceBenefiteds = () => {
  const $form = document.getElementById('form');
  const $totalBenefit = document.querySelector('input[name="total_benefit"]');
  const $notApplicable = document.querySelector('input[name="not_applicable"]');

  $form.addEventListener('submit', e => {
    if (!$totalBenefit.value.length && !$notApplicable.checked) {
      e.preventDefault();
      Swal.fire('', tr[lang].modal_error, 'error');
    }
  });

  $notApplicable.addEventListener('change', e => {
    if (e.target.checked) {
      $totalBenefit.value = '';
    }
  });

  $totalBenefit.addEventListener('input', e => {
    if (e.target.value.length) {
      $notApplicable.checked = false;
    }
  });
};
